import React, { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import Spinner from '../../Spinner';
import Sheet from '../../../models/Sheet';
import useOption from '../../../hooks/useOption';

export default function SinglePoseMutator({
  cartId,
  imageTypes = [],
  onSave,
  optionId,
  orderPackage,
  studentId,
  schoolId,
  packageId,
  poses,
}) {
  const { data: option } = useOption(optionId, schoolId);

  const {
    mutate,
    isLoading,
  } = useMutation({
    mutationFn: async ({ sheets, additionalPoses }) => {
      // Destroy any sheets on the orderPackage (if any), and replace with the new sheets
      const oldSheets = orderPackage.sheets.map((sheet) => {
        sheet.isMarkedForDestruction = true;

        return sheet;
      });

      orderPackage.sheets = oldSheets;

      await orderPackage.save({ with: 'sheets' });

      const newSheets = sheets.map((sheetParams) => new Sheet({ ...sheetParams }));

      orderPackage.cartId = cartId;
      orderPackage.studentId = studentId;
      orderPackage.optionId = option.id;
      orderPackage.packageId = packageId;
      orderPackage.apiOption = option;
      orderPackage.extraPoses = additionalPoses;
      orderPackage.sheets = [...newSheets];

      return orderPackage.save({ with: 'sheets' });
    },
    onSuccess: () => {
      if (Object.keys(orderPackage.errors).length > 0) return;

      onSave();
    },
  });

  useEffect(() => {
    if (imageTypes.length === 0) return;
    if (!option) return;

    const sheets = imageTypes.map((imageType, i) => ({
      imageType,
      imageTypeId: imageType.id,
      index: i,
      poseId: poses[0].id,
      pose: poses[0],
    }));

    mutate({ sheets, additionalPoses: 0 });
  }, [imageTypes.length, option]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'Sen, sans-serif', padding: '2rem', }}>
      <div style={{ marginBottom: '1rem' }}>Creating your package...</div>
      <Spinner color="blue" />
    </div>
  );
}
